module.exports = __webpack_public_path__ + "img/icons B_24.19f469a6.svg";